import client from './client';
import type { HistoryDateInfo, HistoryPreviewResult } from '../types';

/** 获取可用日期列表 */
export async function fetchHistoryDates(): Promise<HistoryDateInfo[]> {
  const res = await client.get<HistoryDateInfo[]>('/history/dates');
  return res.data;
}

/** 获取某日数据预览（分页） */
export async function fetchHistoryPreview(params: {
  date: string;
  page?: number;
  size?: number;
  sort?: string;
  order?: 'asc' | 'desc';
  search?: string;
}): Promise<HistoryPreviewResult> {
  const res = await client.get<HistoryPreviewResult>('/history/preview', { params });
  return res.data;
}

/** 手动保存当日快照 */
export async function saveSnapshot(): Promise<{ date: string; saved: number; total: number }> {
  const res = await client.post<{ date: string; saved: number; total: number }>('/history/snapshot');
  return res.data;
}

/** 构建下载 CSV 的 URL */
export function getDownloadUrl(date: string): string {
  return `/api/history/download?date=${encodeURIComponent(date)}`;
}
